import { useMemo } from "react";
import { useLoggedInUser } from "@/components/providers/ApiProvider/hooks";
import { useLibraryControllerGetLibrary } from "@/lib/lutely-api/gen/library/library";

/**
 * Saved/followed state for the logged-in user, backed by the single
 * `GET /library` query. Logged-out users get empty sets (nothing saved).
 */
export const useLibrary = () => {
  const { data: user } = useLoggedInUser();
  const isLoggedIn = !!user;

  const { data: library } = useLibraryControllerGetLibrary({
    query: { enabled: isLoggedIn },
  });

  const savedTrackIds = useMemo(
    () => new Set(library?.savedTrackIds),
    [library?.savedTrackIds],
  );
  const savedAlbumIds = useMemo(
    () => new Set(library?.savedAlbumIds),
    [library?.savedAlbumIds],
  );
  const followedCreatorIds = useMemo(
    () => new Set(library?.followedCreatorIds),
    [library?.followedCreatorIds],
  );

  return {
    isLoggedIn,
    isTrackSaved: (trackId: string) => savedTrackIds.has(trackId),
    isAlbumSaved: (albumId: string) => savedAlbumIds.has(albumId),
    isCreatorFollowed: (creatorId: string) => followedCreatorIds.has(creatorId),
  };
};
